
























import { Vue, Component, Prop } from 'vue-property-decorator';
import Container from './Registration/Container.vue';
import RegistrationCard from './Registration/Card.vue';
import CardHeader from './Registration/Header.vue';
import SsoLogin from './Registration/SsoLogin.vue';
import LoginForm from './Registration/LoginForm.vue';
import FindJobsLink from './Registration/FindJobsLink.vue';
import LoginFooter from './Registration/LoginFooter.vue';
import { AuthParams } from '@/models/userdata/authparams';
import { OAuthPassport } from '@/models/userdata/socialauthparams';
import { vxm } from './../store.vuex';

@Component({
  components: {
    Container,
    RegistrationCard,
    CardHeader,
    SsoLogin,
    LoginForm,
    LoginFooter,
    FindJobsLink,
  },
})
export default class Login extends Vue {
  @Prop() sessionExpired;
  private emailRegex: RegExp = new RegExp(
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
  );
  private authParams: AuthParams = new AuthParams();
  private errorString: string = '';
  private rememberMe: boolean = this.$cookies.get('rememberMe') === 'true';
  $wlToastr: any;
  private errors = {
    username: '',
    password: '',
  };

  beforeMount() {
    const urlParams = new URLSearchParams(location.search);
    if (vxm.utility.useLoginSignupV2 && !urlParams.has('code')) {
      this.$router.push('/v2/login');
    }
  }

  get tagLine() {
    return vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE')
  }
  get canShowFindJobs() {
    return !vxm.configs.getGlobalConfigBooelanValue('DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN')
  }
  setRememberMe(value) {
    this.rememberMe = value;
  }
  authenticate() {
    this.authParams.companyCode = this.$store.state.jobs.companyCode;
    if (this.validateLoginData(this.authParams)) {
      if (this.rememberMe) {
        this.$cookies.set('userName', this.authParams.username);
        this.$cookies.set('rememberMe', this.rememberMe);
      } else {
        this.$cookies.remove('userName');
        this.$cookies.remove('rememberMe');
      }

      const respPromise = vxm.users.login(this.authParams).then((value) => {
        if (value === false) {
          const errorMessageText =
            vxm.users.getErrorMesaageLogin !== ''
              ? vxm.users.getErrorMesaageLogin
              : this.$t('login.failure');
          this.$wlToastr('error', errorMessageText, 'Sign In');
        }
      });
    }
  }

  validateLoginData(authParams: AuthParams): boolean {
    let formValid = true;
    this.errors = {
      username: '',
      password: '',
    };
    if (!this.emailRegex.test(authParams.username)) {
      this.errors.username = 'login.email.invalid';
    }
    if (!authParams.username) {
      this.errors.username = 'login.email.required';
    }
    if (!authParams.password) {
      this.errors.password = 'login.password.required';
    }
    Object.keys(this.errors).forEach((field) => {
      formValid = formValid && !this.errors[field];
    });
    return formValid;
  }
  getOAuthProvider(): string {
    return this.$cookies.get('OAuthProvider');
  }
  loginWithApple() {
    this.$cookies.set('OAuthProvider', 'apple', 300);
    return vxm.users.loginWithApple();
  }
  facebookLogin() {
    this.$cookies.set('OAuthProvider', 'facebook', 300);
    return vxm.users.loginWithFacebook();
  }
  googleLogin() {
    this.$cookies.set('OAuthProvider', 'google', 300);
    return vxm.users.loginWithGoogle();
  }
  linkedinLogin() {
    this.$cookies.set('OAuthProvider', 'linkedin', 300);
    return vxm.users.loginWithLinkedin();
  }
  mounted() {
    if (this.sessionExpired) {
      this.$wlToastr(
        'info',
        'Your session has timed out. Please sign in again.',
        'Session Timeout',
      );
    }
    console.log('window.location.href');
    console.log(window.location.href);
    this.authParams.username = this.$cookies.get('userName');
    this.authParams.password = this.$cookies.get('password');
    if (window.location.href.indexOf('?') >= 0)
      window.location.href
        .split('?')[1]
        .split('&')
        .forEach((elm) => {
          if (elm.indexOf('code') >= 0) {
            const token = elm.split('=')[1];
            console.log('token ', token);
            console.log('token', decodeURI(token));
            const ccode = decodeURI(token.replace('%2F', '/').replace('=', ''));
            console.log('this.getOAuthProvider()');
            console.log(this.getOAuthProvider());
            if (this.getOAuthProvider() === 'apple') {
              const oauthPassport = new OAuthPassport();
              oauthPassport.email = String(this.$route.query.email);
              oauthPassport.oAuthToken = String(ccode);
              oauthPassport.oAuthProvider = 'apple';
              vxm.users.socialLogin(oauthPassport);
            }

            if (this.getOAuthProvider() === 'facebook') {
              vxm.users.validateFacebookOAuthCode(ccode);
            }

            if (this.getOAuthProvider() === 'dropbox') {
              vxm.users.getDropboxCreds(ccode);
            }

            if (this.getOAuthProvider() === 'google') {
              vxm.users.validateGoogleOAuthCode(ccode);
            }

            if (this.getOAuthProvider() === 'linkedin') {
              vxm.users.validateLinkedinOAuthCode(ccode);
            }

            if (this.getOAuthProvider() === 'facebook_post') {
              // vxm.users.validateFacebookOAuthCode(ccode)
            }

            if (this.getOAuthProvider() === 'google_contacts') {
              // vxm.users.validateGoogleOAuthCode(ccode)
              vxm.referrals.getGoogleContacts(ccode);
            }

            if (!this.getOAuthProvider()) {
              this.$router.push('login');
            }
          }
        });
  }
}
